var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricCar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 111,
    viewBox: "0 0 110 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_1396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 84.9476V26.4924C17.1875 14.6318 26.779 5.01685 38.6109 5.01685H25.5664C13.7008 5.01685 4.08203 14.6356 4.08203 26.5012V84.9388C4.08203 96.8041 13.7008 106.423 25.5664 106.423H38.6109C26.779 106.423 17.1875 96.8082 17.1875 84.9476Z",
    fill: "#CEE1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4023 105.226C70.1826 106.001 67.7967 106.423 65.3125 106.423H25.7812C13.9156 106.423 4.29688 96.8041 4.29688 84.9388V26.5012C4.29688 14.6356 13.9156 5.01685 25.7812 5.01685H65.3125C77.1779 5.01685 86.7969 14.6356 86.7969 26.5012V49.0598M54.7852 83.0052H71.1133M21.4844 82.7903L25.4341 86.8814C27.1343 88.5881 29.8912 88.5881 31.5915 86.8814L39.7461 78.4934",
    stroke: "#405FF2",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.047 70.7828C100.32 68.9446 97.1951 68.6821 94.8535 68.6821C90.5029 68.6821 87.0117 72.2089 87.0117 76.5597C87.0117 80.9105 90.9148 84.4374 96.6917 84.4374C101.681 84.4374 105.703 87.9643 105.703 92.3151C105.703 96.6657 101.961 100.193 97.6106 100.193C95.5763 100.193 91.0458 99.5323 86.582 97.7579M96.6797 68.6821V61.7355M96.6797 100.193V106.423M57.793 58.5129V60.2316M34.1602 58.5129V60.2316",
    stroke: "#FF5CF4",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5352 37.4583H68.1835C68.1734 37.4346 68.1661 37.4102 68.1557 37.3867L64.3038 28.8403C64.3002 28.8323 64.2967 28.8246 64.2931 28.8166C62.5023 24.9067 58.9291 22.0417 54.734 21.1529C52.2427 20.6253 49.1996 20.2708 45.8829 20.2708C42.6308 20.2708 39.6816 20.6128 37.2649 21.122C33.0507 22.0102 29.4639 24.8777 27.6706 28.7928C27.6669 28.8007 27.6635 28.8087 27.6598 28.8166L23.7974 37.3865C23.7869 37.4099 23.7798 37.4343 23.7697 37.458H23.418C21.0448 37.458 19.1211 39.3818 19.1211 41.7549C19.1211 44.1281 21.0448 46.0518 23.418 46.0518V50.023C23.418 55.5337 27.8339 60.0169 33.2617 60.0169H58.6912C64.1193 60.0169 68.5352 55.5337 68.5352 50.0232V46.052C70.9083 46.052 72.832 44.1283 72.832 41.7551C72.832 39.382 70.9083 37.4583 68.5352 37.4583ZM35.4885 32.3615C36.1541 30.9169 37.4799 29.8593 39.0369 29.5312C40.6093 29.1999 42.9015 28.8645 45.8831 28.8645C48.9326 28.8645 51.3212 29.2145 52.953 29.5602C54.4951 29.887 55.811 30.9427 56.4755 32.3854L58.7617 37.4583H33.1914L35.4885 32.3615ZM35.0195 53.7864C32.1718 53.7864 29.8633 51.4778 29.8633 48.6301C29.8633 45.7824 32.1718 43.4739 35.0195 43.4739C37.8673 43.4739 40.1758 45.7824 40.1758 48.6301C40.1758 51.4778 37.8673 53.7864 35.0195 53.7864ZM56.9336 53.7864C54.0858 53.7864 51.7773 51.4778 51.7773 48.6301C51.7773 45.7824 54.0858 43.4739 56.9336 43.4739C59.7813 43.4739 62.0898 45.7824 62.0898 48.6301C62.0898 51.4778 59.7813 53.7864 56.9336 53.7864Z",
    fill: "#FF5CF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_1396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white",
    transform: "translate(0 0.719971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricCar2);
export default __webpack_public_path__ + "static/media/electric-car2.e5a992edad0a871d8be23b0d41dbae39.svg";
export { ForwardRef as ReactComponent };